import { View, StyleSheet } from 'react-native';
import { Icon } from 'react-native-paper';
import Animated, { type SharedValue, useAnimatedStyle, interpolate } from 'react-native-reanimated';

interface MicrophoneVisualProps {
  readonly level: SharedValue<number>;
  readonly isPaused?: boolean;
}

const OUTER_SIZE = 156;
const INNER_SIZE = 121;
const ICON_SIZE = 82;
const OUTER_MAX_SCALE = 1.25;
const INNER_MAX_SCALE = 1.18;

export const MicrophoneVisual = ({ level, isPaused = false }: MicrophoneVisualProps) => {
  const outerRingStyle = useAnimatedStyle(() => {
    const scale = interpolate(level.value, [0, 1], [1, OUTER_MAX_SCALE]);
    const opacity = interpolate(level.value, [0, 0.5, 1], [0, 0.6, 1]);

    return { transform: [{ scale }], opacity };
  });

  const innerRingStyle = useAnimatedStyle(() => {
    const scale = interpolate(level.value, [0, 1], [1, INNER_MAX_SCALE]);
    const opacity = interpolate(level.value, [0, 0.5, 1], [0, 0.7, 1]);

    return { transform: [{ scale }], opacity };
  });

  const micColor = isPaused ? '#BDBDBD' : '#4CAF50';

  return (
    <View style={styles.container}>
      {!isPaused && <Animated.View style={[styles.outerRing, outerRingStyle]} />}
      {!isPaused && <Animated.View style={[styles.innerRing, innerRingStyle]} />}
      <View style={styles.iconContainer}>
        <Icon source="microphone" size={38} color={micColor} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: OUTER_SIZE * OUTER_MAX_SCALE,
    height: OUTER_SIZE * OUTER_MAX_SCALE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  outerRing: {
    position: 'absolute',
    width: OUTER_SIZE,
    height: OUTER_SIZE,
    borderRadius: OUTER_SIZE / 2,
    backgroundColor: '#C8E6C9',
  },
  innerRing: {
    position: 'absolute',
    width: INNER_SIZE,
    height: INNER_SIZE,
    borderRadius: INNER_SIZE / 2,
    backgroundColor: '#A5D6A7',
  },
  iconContainer: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    borderRadius: ICON_SIZE / 2,
    backgroundColor: '#ffffff',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.08,
    shadowRadius: 11,
    elevation: 3,
  },
});
